<template>
  <base-list-view
    @state-scroll="scrollList"
  >
    <template v-slot:filter-slot>
      <button
          @click="showFilter"
          class="up-btn-filters"
        >
        {{ $t('shared.filters.btn_open') }} <i class="exu-filter-funnel-02"/>
      </button>
    </template>
    <template
      v-if="isShowFilter"
      v-slot:aside-filter-slot
    >
      <filters-view
        :filters="filters"
        :selectedFilters="filtersState"
        :levelTitles="filterLevelTitles"
        @update="applyFilters"
      />
    </template>
    <div class="exhibitor-list">
      <pre-loader v-if="isLoadingPrev"/>
      <div
        v-for="exhibitor in exhibitorsList"
        :key="exhibitor.id"
        class="exhibitor-item"
      >
        <exhibitor-card
          :exhibitor-id="exhibitor.id"
          :logo="exhibitor.logo"
          :company="exhibitor.name"
          :stand="exhibitor.stand"
          :marked="!!getMarkedCompanyByID(exhibitor.id)"
          @marking="markingCompany"
        />
      </div>
      <system-card
        v-if="systemMessage"
        :system-message="systemMessage"
        :cbFunc="repeatGetPage"
      />
      <pre-loader v-if="isLoading && !isLoadingPrev"/>
    </div>
  </base-list-view>
</template>
<script>
import { DateTime } from 'luxon';
import appBaseNav from '@/components/mixins/appBaseNav';
import exhibitors from '@/components/mixins/methodsExhibitors';
import filters from '@/components/mixins/api/apiMethodsCatalogFilters';
import banners from '@/components/mixins/methodsBanners';
import listScrollMixin from '@/components/mixins/viewers/listScrollMixin';

import baseListView from '@/components/shared/baseListView.vue';
import SystemCard from '@/components/shared/upCard/SystemCard.vue';
import ExhibitorCard from '@/components/shared/upCard/ExhibitorCard.vue';
import FiltersView from '@/components/shared/asideMenu/asideFilters.vue';

export default {
  name: 'ListExhibitorsView',
  components: {
    baseListView, SystemCard, ExhibitorCard, FiltersView,
  },
  props: {
    launchDownload: {
      type: Boolean,
    },
    locale: {
      type: String,
    },
    page: {
      type: String,
      default: null,
    },
  },
  data() {
    const startPage = parseInt(this.page, 10) || 1;
    return {
      exhibitorsList: [],
      markedExhibitors: [],
      filters: [],
      isLoading: true,
      firstPage: startPage,
      curPage: startPage,
      countPage: null,
      searchInput: null,

      isFiltered: false,
      filtersState: {},
      filterParams: null,

      isShowFilter: false,
      isLoadingPrev: false,
      isLastDownloaded: false,
      systemMessage: null,
    };
  },
  mixins: [appBaseNav, exhibitors, banners, filters, listScrollMixin],
  computed: {
    // имён вложенных уровней конфиг не отдаёт — подписи для салонов задаём здесь
    filterLevelTitles() {
      return {
        category: [
          this.$t('exhibitorsList.filter_level_group'),
          this.$t('exhibitorsList.filter_level_section'),
        ],
      };
    },
  },
  mounted() {
    this.$store.commit('setPageTitle', this.$t('exhibitorsList.header_title'));
    this.loadMarkedExhibitors();
    Promise.all([
      this.getBanner('exhibitor', this.$store.getters.getBannerExhibitorTs),
      // конфиг фильтров не должен ронять каталог: не отдался — работаем без него
      this.getFilters('exhibitor').catch(() => []),
    ])
      .then(([
        banner,
        filter,
      ]) => {
        this.isLoading = false;
        if (banner && Object.keys(banner).length) {
          this.$emit('showBanner', banner);
          const nowMilis = DateTime.now().toMillis();
          localStorage.setItem('bannerExhibitorTs', nowMilis);
          this.$store.commit('setBannerExhibitorTs', nowMilis);
        }

        if (Array.isArray(filter)) {
          this.filters = [...filter];
        }

        this.getPage();
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  methods: {
    getPage(params = null) {
      if (this.countPage === null || this.curPage <= this.countPage) {
        this.isLoading = true;

        this.getExhibitorList(this.curPage, this.searchInput, params)
          .then((data) => {
            this.isLoading = false;
            this.$emit('turnOff', {
              stateDownload: false,
              stateCheckInbox: false,
            });
            if (data?.results && Array.isArray(data.results)) {
              this.exhibitorsList = [...this.exhibitorsList, ...data.results];
              this.countPage = data.num_pages;
              this.curPage = data.page;
              this.isLastDownloaded = true;
              this.systemMessage = null;
              this.$nextTick(() => { this.checkScrollBoundaries(); });
            } else {
              this.isLastDownloaded = false;
              this.systemMessage = this.$t('system.bad_connect');
            }
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('getPage()::', error);
          });
      }
    },
    getPrevPage() {
      if (this.firstPage <= 1) return;

      const scrollEl = document.getElementById('content__wrapper');
      const listEl = document.getElementById('listView');

      const heightBeforeLoader = listEl.offsetHeight;
      const scrollBeforeLoader = scrollEl.scrollTop;

      this.isLoading = true;
      this.isLoadingPrev = true;

      this.$nextTick(() => {
        this.adjustScroll(scrollBeforeLoader, heightBeforeLoader);
      });

      this.getExhibitorList(this.firstPage - 1, this.searchInput, this.filterParams)
        .then((data) => {
          if (data?.results && Array.isArray(data.results)) {
            const heightBeforeData = listEl.offsetHeight;
            const scrollBeforeData = scrollEl.scrollTop;

            this.isLoading = false;
            this.isLoadingPrev = false;
            this.exhibitorsList = [...data.results, ...this.exhibitorsList];
            this.firstPage -= 1;
            this.systemMessage = null;

            this.$nextTick(() => {
              this.adjustScroll(scrollBeforeData, heightBeforeData);
            });
          } else {
            this.isLoading = false;
            this.isLoadingPrev = false;
            this.systemMessage = this.$t('system.bad_connect');
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('getPrevPage()::', error);
          this.isLoading = false;
          this.isLoadingPrev = false;
        });
    },
    loadMarkedExhibitors() {
      const exhID = this.$store.getters.getExhId;
      const markedList = localStorage.getItem(`exh-${exhID}-marked`);
      if (markedList === null) {
        localStorage.setItem(`exh-${exhID}-marked`, JSON.stringify([]));
      } else {
        JSON.parse(markedList).forEach((item) => {
          if (item.type === 'exhibitors') {
            this.markedExhibitors.push(item);
          }
        });
      }
    },
    saveMarkedExhibitors() {
      const exhID = this.$store.getters.getExhId;
      localStorage.setItem(`exh-${exhID}-marked`, JSON.stringify(this.markedExhibitors));
    },
    showFilter() {
      this.isShowFilter = !this.isShowFilter;
    },
    markingCompany(item) {
      const company = this.exhibitorsList.find((companyItem) => companyItem.id === item);
      const markedCompany = this.markedExhibitors
        .findIndex((companyItem) => companyItem.id === item);

      if (markedCompany === -1) {
        this.markedExhibitors.push({
          type: 'exhibitors',
          id: company.id,
        });
      } else {
        this.markedExhibitors.splice(markedCompany, 1);
      }

      this.saveMarkedExhibitors();
    },
    getCompanyByID(companyID) {
      return this.exhibitorsList.find((company) => company.id === companyID);
    },
    getMarkedCompanyByID(companyID) {
      return this.markedExhibitors.find((company) => company.id === companyID);
    },
    // Поле поиска в панели (`searchable`) здесь пока не включено: сервер
    // параметр `search` для /exhibitor/page/ не применяет. Разбор запроса и
    // подстановка ниже готовы — останется добавить проп в разметке.
    applyFilters(params) {
      this.isShowFilter = false;

      if (params !== null && params.doFilter) {
        this.isFiltered = !!Object.keys(params.filters).length;
        this.filtersState = params.filtersState;
        this.filterParams = this.isFiltered
          ? { filter: JSON.stringify(params.filters) }
          : null;
        this.searchInput = params.search;
        this.resetList();
        this.getPage(this.filterParams);
      } else if (this.isFiltered || this.searchInput) {
        this.isFiltered = false;
        this.filtersState = {};
        this.filterParams = null;
        this.searchInput = null;
        this.resetList();
        this.getPage();
      }
    },
    resetList() {
      this.firstPage = 1;
      this.curPage = 1;
      this.countPage = null;
      this.exhibitorsList = [];
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/style/variables.scss';

.exhibitor {
  &-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  &-list &-item {
    flex: 1 1 140px;
    max-width: calc(50% - 6px);
    @media (min-width: 480px) {
      flex: 1 1 180px;
      max-width: calc(33.333% - 6px);
    }

    & .upCard {
      border-radius: 10px;
      padding: 10px;
      height: 203px;
    }
  }
}
</style>
